import React from 'react';

import Footer from '../Footer'
import './BOREDVILLE.css';


import BOREDVILLE_TOWN from './Assets/BOREDVILLE_TOWN.png';
import AMUSEMENT_PARK from './Assets/AMUSEMENT_PARK.jpg';
import APE_SLEEP from './Assets/APE_SLEEP.png';




function Founder() {
  return (
    <div className="container ">
      <br/>
    
 
      <br />
      <h2 className='Welcome_Boredville'>Welcome To Boredville </h2><br/>
     
 
    

      <p className='Welcome_Boredville_p'>"A Place To Disconnect, Then Reconnect On-Chain ."</p>

<br />
    
      <div className='center_everything'><img
        src={BOREDVILLE_TOWN}
        alt="Meet The Team"
        className="responsive-img-bordville"
        draggable="false" // <-- This disables dragging
      /></div>


<p className='bordvillepu'>
They say Boredville emerged from a dream an ape had during a nap on a beanbag chair — and no one’s been motivated enough to wake him up since. 
<br/><br/>
It’s a town where ‘morning routine’ means staring out the window with cereal and no thoughts, and nobody works Mondays — because their airdrops already did. 



</p>

<br />
    
      <div className='center_everything'><img
        src={AMUSEMENT_PARK}
        alt="Meet The Team"
        className="responsive-img-bordville"
        draggable="false" // <-- This disables dragging
      /></div>


<p className='bordvillepu'>
Grab a coffee at GM Grounds, ride the Rugcoaster (keep your arms and JPEGs inside), or eavesdrop on a squirrel with a name tag explaining tokenomics to a confused mailbox.
<br/>
<br/>
Find your people. Ape responsibly.


</p>


<br/><br/><br/>

 <div className='center_everything'><img
        src={APE_SLEEP}
        alt="Meet The Team"
        className="responsive-img-bordville"
        draggable="false" // <-- This disables dragging
      /></div>


<br/>
<br/>
<br/>
<br/>
<br/>
<br/>






<Footer/>





























    </div>
  );
}

export default Founder;
